import React from "react";
import "./HotelRoomCard.scss";
import Label from "../../components/Label";
import InputBox from "../../components/InputBox";

const formList = [
  {
    id: 1,
    type: "number",
    placeHolder: "",
    label: "Room Count",
    name: "roomCount",
  },
  {
    id: 2,
    type: "number",
    placeHolder: "",
    label: "Adult Count",
    name: "adultCount",
  },
  {
    id: 3,
    type: "number",
    placeHolder: "",
    label: "Children Count",
    name: "childrenCount",
  },
  {
    id: 4,
    type: "number",
    placeHolder: "",
    label: "Price",
    name: "price",
  },
];
const HotelRoomCard = ({ handleDeleteRoom, index, state, handleOnChange }) => {
  const handleChange = (e) => {
    handleOnChange(e, index);
  };
  return (
    <div className="HotelRoomCard">
      <div className="head-wrapper">
        <p className="form-title">{`Room Type ${index + 1}`}</p>
        <button
          className="delete-room-btn"
          onClick={() => handleDeleteRoom(index)}
        >
          X
        </button>
      </div>
      <div className="form-wrapper">
        {formList.map((data, index) => {
          return (
            <div className="input-wrapper">
              <Label value={data.label} />
              <InputBox
                type={data.type}
                name={data.name}
                value={state[data.name]}
                onChange={handleChange}
              />
            </div>
          );
        })}
        <div className="checkbox-wrapper">
          <Label value={"Air Conditioner"} />
          <InputBox
            name="airConditioner"
            type="checkbox"
            checked={state.airConditioner}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default HotelRoomCard;
